import useWorkspacesStore from '@/state/workspaces.state';
import type { EnrichedUserFields } from '@/types/auth.types';

/** Stripe updates the saved subscription asynchronously, after the upgrade request returns. */
export async function refreshSubscription(
  enrichUser: () => Promise<Pick<EnrichedUserFields, 'activeWorkspace'> | undefined>,
  workspaceId: string,
  subscriptionType: string,
  billingCycle: string,
): Promise<void> {
  for (let attempt = 0; attempt < 15; attempt++) {
    if (useWorkspacesStore.getState().activeWorkspace.workspaceId !== workspaceId) return;

    const refreshedUser = await enrichUser();
    if (useWorkspacesStore.getState().activeWorkspace.workspaceId !== workspaceId) return;
    // Check the fetched data directly: React effects may not have synced it to the store yet.
    const workspace = refreshedUser?.activeWorkspace;
    if (
      workspace?.workspaceId === workspaceId &&
      workspace.subscription?.type === subscriptionType &&
      workspace.subscription.billingCycle === billingCycle
    )
      return;

    // Retry stale responses, failed refreshes, and refreshes skipped by enrichUser's in-flight guard.
    if (attempt < 14) await new Promise((resolve) => setTimeout(resolve, 1000));
  }
  // The payment already succeeded. A delayed webhook must not invite another payment attempt.
}
